package diana.soleil.design.iraniancanadienbazzar.core.devmenu

/**
 * A single entry in the Developer Menu. Feature modules contribute their own debug affordances (force a
 * "sponsored" path, jump to a screen, mock an empty/error state, seed data, …) by registering a [DevTool]
 * with the [DevMenuRegistry] instead of bolting one-off debug code into a screen (see docs/DEVELOPER_MENU.md).
 *
 * Labels are already-resolved strings — the contributing module localizes them (though debug-only copy may
 * stay English-only). [onInvoke] runs on the composition's main dispatcher when the row is tapped.
 */
data class DevTool(
    val id: String,
    val iconName: String,
    val title: String,
    val subtitle: String? = null,
    val onInvoke: () -> Unit,
)
